export const scrollLock = async ()=>{
  await new Promise((resolve)=>{
      document.getElementsByTagName('body')[0].classList.add('scrollLock');
  })
}

export const scrollUnLock = async ()=>{
  document.getElementsByTagName("body")[0].classList.remove("scrollLock");
}